'use client'

import React, { useEffect, useState } from 'react'

export function DefaultPageTemplate({ navbar, children, footer }: {
  children: React.ReactNode;
  navbar: React.ReactNode;
  footer?: React.ReactNode;
}) {
  const [hasMounted, setHasMounted] = useState(false)

  useEffect(() => setHasMounted(true), [])

  if (!hasMounted) return null

  return (
    <section>
      {navbar}
      {children}
      {footer && footer}
    </section>
  )
}
